import { Component } from '@angular/core';
import { IonicPage, Modal, ModalController, ActionSheetController, ActionSheet, NavController, LoadingController, ToastController, Loading } from 'ionic-angular';
import { Proxy } from '../../services/proxy/proxy.service';
import { APIOnLine } from '../../services/api/api.services';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { ModalDorsalPage } from '../modal-dorsal/modal-dorsal';
import { IncluirJugadorPage } from '../incluir-jugador/incluir-jugador';
import { PaginaBasica } from '../../models/PaginaBase';
import { NuevaPersonaPage } from '../nueva-persona/nueva-persona';
import { ModalImagePage } from '../modal-image/modal-image';
import { Online } from '../../models/online/cfutbol';
import { iConfiguracion } from '../../models/basePage';
import { Ng2ImgMaxService } from 'ng2-img-max';

@IonicPage()
@Component({
  selector: 'page-jugadores',
  templateUrl: 'jugadores.html',
})
export class JugadoresPage extends PaginaBasica {

  // #region Propiedades de la página
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;
  public configuraciones: iConfiguracion;
  // #endregion

  // #region Propiedades relacionadas con Dropzone y con el archivo de alineación
  public datosFichero: string = "";
  public archivoAlineacion: Online.Actas_Archivos_Alineaciones;
  public necesitaHojaAlineacion: boolean = true;     // Indica si se necesita adjuntar la Hoja de Alineación (por defecto a true)
  // #endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController,
    public ng2ImgMax: Ng2ImgMaxService
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log('--- ENTRO EN LA PÁGINA: JUGADORES ---');
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    if (this.designacion.sinHojaAlineacion) {
      this.necesitaHojaAlineacion = false;     // No se necesita adjuntar la hoja de alineaciones.
    }

    this.MostrarOcultarCarga(false, "cargando jugadores");
    console.log("prueba");

    this.licencias = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.idEquipo);
    this.participantes = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);

    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        this.configuraciones = resultado;
        return this.participantes.CargarListaParticipacion();
      })
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(true, false, false);
      })
      .then((resultado: boolean) => {

        return this.CFutbolActas.archivoAlineacion(this.designacion.urlApi, this.designacion.idDesignacion, this.idEquipo);
      })
      .then((resultado: Online.IActa_Archivos_Alineaciones) => {
        if (resultado.idArchivo > 0) {
          this.archivoAlineacion = <Online.Actas_Archivos_Alineaciones>resultado;
        }

        // Se comprueban los dorsales fijos, por si hay que realizar el proceso de establecimiento de dorsales en los participantes
        if (this.licencias.lista != null && this.licencias.lista.length > 0 && this.licencias.lista.filter(m => m.dorsal != null).length > 0) {
          this.participantes.EstablecerDorsalesFijos(this.licencias)
            .then((resultado: boolean) => {
              this.MostrarOcultarCarga();
            })
            .catch(error => console.error(error));
        }
        else {
          this.MostrarOcultarCarga();
        }
      })
      .catch(error => console.error(error));
  }

  // #region Métodos del controlador

  public ColorCapitan(licencia: Proxy.PrPersonaAlineable): string {
    if (this.participantes.EsCapitan(licencia)) {
      return 'coral';
    }
    else {
      return 'concrete';
    }
  }

  public ColorSuplente(licencia: Proxy.PrPersonaAlineable): string {
    if (this.participantes.EsSuplente(licencia)) {
      return 'melon';
    }
    else {
      return 'concrete';
    }
  }

  public ColorTitular(licencia: Proxy.PrPersonaAlineable): string {
    if (this.participantes.EsTitular(licencia)) {
      return 'auburn';
    }
    else {
      return 'concrete';
    }
  }

  /**
   * Elimina la alineación completa del equipo actual
   */
  public EliminarAlineacion(): void {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Eliminar alineación completa',
      subTitle: 'Al pulsar sobre el botón de ELIMINACIÓN COMPLETA, se reiniciará la alineación del equipo actual.',
      buttons: [
        {
          text: 'ELIMINACIÓN COMPLETA',
          handler: () => {
            this.participantes.EliminarAlineados(this.licencias);
          }
        },
        {
          text: 'Cancelar',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  public EliminarParticipante(licencia: Proxy.PrPersonaAlineable): void {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Eliminar participante',
      subTitle: '¿Desea eliminar de la lista de jugadores a ' + licencia.nombre + ' ' + licencia.apellido1 + ' ' + licencia.apellido2 + '?',
      buttons: [
        {
          text: 'Eliminar',
          handler: () => {
            this.participantes.EliminarParticipante(licencia);
            this.licencias.EliminarAlineado(licencia);
          }
        },
        {
          text: 'Cancelar',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  public IncluirJugador(): void {
    let modal: Modal = this.modalCtrl.create(IncluirJugadorPage);
    modal.onDidDismiss(() => {
      this.participantes.CargarListaParticipacion()
        .then((resultado: boolean) => {
          return this.licencias.ObtenerAlineables(true, false, false);
        })
        .then((resultado: boolean) => {

        })
        .catch(error => console.error(error));
    });
    modal.present();
  }

  /**
   * Carga la página que se encarga de añadir una nueva persona a la lista de jugadores
   */
  public NuevaPersona(): void {
    console.log("Llego al método NuevaPersona");
    let modal: Modal = this.modalCtrl.create(NuevaPersonaPage, {
      esAuxiliar: false,
      esEntrenador: false
    });
    modal.onDidDismiss(() => {
      this.participantes.CargarListaParticipacion()
        .then((resultado: boolean) => {
          return this.licencias.ObtenerAlineables(true, false, false);
        })
        .then((resultado: boolean) => { })
        .catch(error => console.error(error));
    });
    modal.present();
  }

  /**
   * Muestra la ventana modal para cambiar el dorsal de un jugador
   * @param alineado Datos del alineado
   */
  public VentanaDorsal(alineado: Proxy.PrPersonaAlineable): void {
    let tieneDorsalFijo: boolean = (this.participantes.lista.filter(m => m.identificador == alineado.identificador && alineado.dorsal != null && alineado.dorsal > 0).length > 0)
      ? true
      : false;

    // Se comprueba que la licencia no tenga ya dorsal establecido
    if (!tieneDorsalFijo) {
      let modal: Modal = this.modalCtrl.create(ModalDorsalPage, {
        alineado: alineado,
        dorsal: this.participantes.Dorsal(alineado)
      });
      modal.onDidDismiss((data: number) => {
        if (data != undefined) {
          console.log('Dorsal a utilizar: ' + data);

          // Se comprueba que no haya una licencia con dorsal fijo con ese dorsal
          if (this.licencias.lista.filter(m => m.dorsal == data).length > 0) {
            this.Mensaje("El dorsal que ha indicado pertenece a una licencia con DORSAL FIJO. No se puede realizar el cambio solicitado.");
          }
          else {
            if (!this.participantes.DorsalUsado(data)) {
              this.participantes.EstablecerDorsal(alineado, data);
            }
            else {
              let action: ActionSheet = this.actionSheetCtrl.create({
                title: 'Dorsal ya usado',
                subTitle: 'El dorsal que ha seleccionado ya está siendo utilizado por otro jugador. ¿Confirma que desea utilizarlo?',
                buttons: [
                  {
                    text: 'CONFIRMAR',
                    handler: () => {
                      this.participantes.EstablecerDorsal(alineado, data);
                    }
                  },
                  {
                    text: 'Cancelar',
                    role: 'cancel'
                  }
                ]
              });
              action.present();
            }
          }

        }
      });
      modal.present();
    }
  }

  /**
   * Muestra una ventana modal con la foto asociada a la persona
   * @param licencia Datos de la licencia
   */
  public VerFoto(licencia: Proxy.PrPersonaAlineable): void {
    let modal: Modal = this.modalCtrl.create(ModalImagePage, {
      dni: licencia.identificador
    });
    modal.present();
  }

  // #endregion

  // #region Métodos para Dropzone

  /**
   * Elimina el archivo de alineación asociado con la designación y el equipo actual
   */
  public EliminarFicheroAlineacion(): void {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Eliminar archivo de alineación',
      subTitle: '¿Desea eliminar el archivo con la información de la alineación?',
      buttons: [
        {
          text: 'Eliminar',
          handler: () => {
            this.MostrarOcultarCarga();

            this.CFutbolActas.eliminarArchivoAlineacion(this.designacion.urlApi, this.designacion.idDesignacion, this.idEquipo)
              .then((resultado: boolean) => {
                this.archivoAlineacion = undefined;
                this.MostrarOcultarCarga();
              })
              .catch(error => this.Error(error, "EliminarFicheroAlineacion"));
          }
        },
        {
          text: 'Cancelar',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  /**
   * Guarda en el servidor, el archivo con la alineación que se ha seleccionado
   */
  public GuardarFicheroAlineacion(): void {
    let alineacionConDatos: Online.Actas_Archivos_Alineaciones_ConDatos = {
      archivo: this.datosFichero,
      acta_archivos: {
        archivo: "",
        fechaInsercion: "",
        idArchivo: 0,
        idDesignacion: this.designacion.idDesignacion,
        idEquipo: this.idEquipo,
        urlApi: this.designacion.urlApi,
        urlNombre: this.designacion.urlNombre
      },
      urlApi: this.designacion.urlApi,
      urlNombre: this.designacion.urlNombre
    };

    this.MostrarOcultarCarga(false, "... subiendo archivo ...");

    this.CFutbolActas.guardarArchivoAlineaciones(alineacionConDatos)
      .then((resultado: Online.Actas_Archivos_Alineaciones) => {
        console.log(resultado);
        this.archivoAlineacion = resultado;

        this.MostrarOcultarCarga(true);
      });
  }

  /**
   * Procesa el archivo que se ha seleccionado desde el componente DropZone. Realiza la compresión del archivo a 1Mbyte.
   * @param files Ficheros seleccionados
   */
  public onFilesAdded(files: File[]): void {
    let cargaImagen: Loading = this.loadingCtrl.create({
      spinner: 'dots',
      content: "comprimiendo imagen"
    });
    cargaImagen.present();

    this.datosFichero = "";
    files.forEach(file => {
      this.ng2ImgMax.compressImage(file, 1).subscribe(
        result => {
          this.LeerArchivo(result, cargaImagen);
        },
        error => {
          console.log("Error al intentar redimensionar la imagen.");
          console.error(error);
          cargaImagen.dismissAll();
          this.Error(error, "Error al intentar redimensionar el arhivo o foto seleccionada.");
        }
      );
    });
  }

  /**
   * Procesa el archivo que es pasado como parámetro para guardarlo en formato Base64 en la instancia "datosFichero". Una vez realiza la operación, cierra el "Loading"
   * @param file Archivo
   * @param cargaImagen Loading
   */
  private LeerArchivo(file: any, cargaImagen: Loading): void {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent) => {
      const content = (e.target as FileReader).result;
      this.datosFichero = content.toString();
      cargaImagen.dismiss();
    };
    reader.readAsDataURL(file);
  }

  /**
   * Devuelve la ruta completa del archivo de alineación
   */
  public RutaArchivoAlineacion(): string {
    let resultado: string = "";
    if (this.archivoAlineacion != undefined) {
      return this.configuraciones.api.urlArchivoAlineacion + this.archivoAlineacion.archivo;
    }
    return resultado;
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/jugadores/jugadores.ts